import { Service } from '../service.js';
import { env } from '../env.js';

class FormularioTarefaService extends Service {
  constructor(controleDeInstancia) {
    super(controleDeInstancia);

    this.url = env.url + 'formulario-tarefa';

    this.controladoresDeInstancia = {
      listar: new AbortController(),
      editar: new AbortController(),
      confirmar: new AbortController()
    };
  }

  async getDadosPelaKey(objetoDeFiltros, controlador) {
    this.controladoresDeInstancia.listar = this.selecionarControlador(controlador);
    const queryString = this.converterObjetoDeFiltrosParaURIEncodedString(objetoDeFiltros);
    const url = `${this.url}/buscar-formulario${queryString}`;
    
    const init = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.adquirirToken(),
      },
      signal: this.controladoresDeInstancia.listar.signal
    };
    
    const response = await fetch(url, init);
    
    if (response.ok) {
      return response.json();
    }
    
    if (response.status === 400) {
      const responseJson = await response.json();
      throw new Error(`HTTP 400: ${responseJson.message || ''}`);
    }
    
    throw new Error('HTTP ' + response.status);
  }

  async getDadosPeloId(id, controlador) {
    this.controladoresDeInstancia.listar = this.selecionarControlador(controlador);
    const url = `${this.url}/${id}`;
    return super.get(url, this.controladoresDeInstancia.listar);
  }

  async editarPelaKey(modelo, controlador) {
    this.controladoresDeInstancia.editar = this.selecionarControlador(controlador);
    const url = `${this.url}/editar-formulario`;
    const response = await super.patch(url, modelo, this.controladoresDeInstancia.editar);
    
    if (response.ok) {
      return;
    } else {
        const responseJson = await response.json()
        throw new Error(responseJson.message? responseJson.message : `HTTP ${response.status}`);
    }
  }

  async confirmarDados(id, controlador) {
    if (!id || typeof id !== 'object' || !id.id) {
      throw new Error('ID inválido para confirmação de dados');
    }
    
    this.controladoresDeInstancia.confirmar = this.selecionarControlador(controlador);
    const url = `${this.url}/confirmar-dados`;
    const response = await super.patch(url, id, this.controladoresDeInstancia.confirmar);
    
    if (response.ok) {
      return;
    } else {
      const responseJson = await response.json().catch(() => ({}));
      throw new Error(responseJson.message || `HTTP ${response.status}`);
    }
  }
}

export const formularioTarefaService = new FormularioTarefaService();
